/**
 * ¿El rol actual puede ver todos los clientes de la empresa?
 * Si no, el listado debe limitarse al worker (p. ej. GET /clients?scope=mine).
 */
export function seesAllCompanyClients(role) {
  if (!role || typeof role !== 'string') return false
  const r = role
    .toLowerCase()
    .normalize('NFD')
    .replace(/\p{M}/gu, '')
  return (
    r === 'owner' ||
    r === 'admin' ||
    r === 'administrador' ||
    r === 'worker-admin'
  )
}

/** Listado GET /clients: `all` si no hay rol aún o es admin; `mine` solo para workers no admin. */
export function resolveClientsListScope(role) {
  if (role == null || role === '') return 'all'
  return seesAllCompanyClients(role) ? 'all' : 'mine'
}
